import SEO from "@/components/SEO";

export default function Privacy() {
  return (
    <section className="section-pad">
      <SEO
        path="/privacy"
        title="Privacy & Cookie Policy"
        description="Informativa sulla privacy e sull'uso dei cookie del sito robertacastagna.it. Titolare del trattamento: Roberta Castagna, P. IVA 06241190872."
      />
      <div className="max-w-3xl mx-auto px-6">
        <p className="eyebrow mb-4">Informativa</p>
        <h1 className="font-display text-4xl sm:text-5xl text-[#2A3229] leading-tight mb-8">Privacy & Cookie Policy</h1>
        <div className="space-y-6 text-[#2A3229] leading-relaxed">
          <p className="text-[#5A6058]">Ultimo aggiornamento: {new Date().getFullYear()}</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">1. Titolare del trattamento</h2>
          <p>Titolare del trattamento dei dati è <strong>Roberta Castagna</strong> — Business Consultant, P. IVA 06241190872, Gravina di Catania. Email: robertacastagna1@gmail.com.</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">2. Dati raccolti</h2>
          <p>Raccogliamo i dati che fornisci volontariamente tramite i moduli del sito (Check-Up di Assetto Aziendale, richieste di contatto, prenotazioni): nome e cognome, email, numero di telefono, nome azienda, ruolo, dimensione del team e le risposte fornite al questionario diagnostico.</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">3. Finalità del trattamento</h2>
          <p>I dati sono trattati per: elaborare il report personalizzato del Check-Up, ricontattarti per una consulenza, rispondere alle tue richieste e — solo previo consenso esplicito — inviarti contenuti e strategie via email (newsletter).</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">4. Base giuridica</h2>
          <p>Il trattamento si basa sul consenso dell'interessato (art. 6.1.a GDPR) e sull'esecuzione di misure precontrattuali adottate su richiesta dello stesso (art. 6.1.b GDPR).</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">5. Conservazione</h2>
          <p>I dati vengono conservati per il tempo strettamente necessario alle finalità indicate e comunque nel rispetto degli obblighi di legge. Puoi richiederne la cancellazione in qualsiasi momento.</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">6. Cookie</h2>
          <p>Il sito utilizza cookie tecnici necessari al funzionamento (es. gestione della sessione di accesso all'area riservata). Non utilizziamo cookie di profilazione di terze parti senza il tuo consenso. Proseguendo la navigazione o cliccando "Accetto" acconsenti all'uso dei cookie tecnici.</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">7. Diritti dell'interessato</h2>
          <p>Ai sensi degli artt. 15-22 GDPR hai diritto di accedere ai tuoi dati, rettificarli, cancellarli, limitarne il trattamento, opporti e richiederne la portabilità. Per esercitare questi diritti scrivi a robertacastagna1@gmail.com.</p>

          <h2 className="font-display text-2xl text-[#323C36] mt-8">8. Contatti</h2>
          <p>Per qualsiasi domanda relativa a questa informativa puoi contattare il Titolare all'indirizzo robertacastagna1@gmail.com.</p>
        </div>
      </div>
    </section>
  );
}
